import React, { Component } from "react";
import { withCompanies } from "../../../../shared/containers/containerCompanies";

import ControlPointIcon from "@mui/icons-material/ControlPoint";
import AddTaskIcon from "@mui/icons-material/AddTask";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import Input from "../../../../shared/items/contols/input";

import { states } from "../../../../reducers/queriesStates";
import styles from "../cmsCompanies.module.scss";

class CmsCreateOwnershipAreaTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isView: false,
      isError: false,
      title: null,
    };
  }

  componentDidUpdate(prevPeops) {
    const { createOwnershipAreaDataState } = this.props;

    if (createOwnershipAreaDataState === states.READY && prevPeops.createOwnershipAreaDataState === states.REQUEST) {
      this.setState({ isView: false });
    }

    if (createOwnershipAreaDataState === states.FAILURE && prevPeops.createOwnershipAreaDataState === states.REQUEST) {
      this.setState({ isError: true, isView: false });

      setTimeout(() => {
        this.setState({ isError: false, isView: false });
      }, 3000);
    }
  }

  onChangeTitleOwnershipArea(name, title) {
    this.setState({ title });
  }

  onCreateOwnershipArea() {
    const { onCreateOwnershipArea } = this.props;
    const { title } = this.state;

    if (title !== null && title !== "") {
      onCreateOwnershipArea({ title });
    }
  }

  render() {
    const { isView, isError } = this.state;

    if (isError) {
      return (
        <div className={styles.createToolsContainer}>
          <div style={{ color: "red" }}>{"Не удалось создать область владения"}</div>
        </div>
      );
    }

    return !isView ? (
      <div className={styles.createToolsContainer}>
        <TooltipWrapper title={"Создать область владения"} position="left">
          <ControlPointIcon
            className={styles.icon}
            fontSize="large"
            onClick={() => {
              this.setState({ isView: !isView });
            }}
          />
        </TooltipWrapper>
      </div>
    ) : (
      <div className={styles.createToolsContainer}>
        <TooltipWrapper title={"Отмена"} position="left">
          <HighlightOffIcon
            className={styles.icon}
            fontSize="large"
            onClick={() => {
              this.setState({ isView: !isView });
            }}
          />
        </TooltipWrapper>
        <div className={styles.inputText}>
          <Input
            name="ownershipTitle"
            type="text"
            placeholder="Область владения"
            handleChangeStore={this.onChangeTitleOwnershipArea.bind(this)}
          />
        </div>
        <TooltipWrapper title={"Создать"} position="left">
          <AddTaskIcon className={styles.iconAdd} fontSize="large" onClick={this.onCreateOwnershipArea.bind(this)} />
        </TooltipWrapper>
      </div>
    );
  }
}

export default withCompanies(CmsCreateOwnershipAreaTools);
